import { motion } from "framer-motion";
import { useTapAnimation } from "@/lib/motion";
import { cn } from "@/lib/utils";

// Botones de la landing: las clases de CLAUDE.md ("Buttons") con el spring de `lib/motion.js`.
// Son enlaces (`<a>`) porque todos llevan a un ancla, a /login o a WhatsApp — ninguno envía nada
// salvo el del formulario, que usa `as="button"`.

const VARIANTES = {
  primario:
    "bg-indigo-600 text-white shadow-sm hover:bg-indigo-700 hover:shadow-md focus-visible:ring-indigo-300",
  secundario:
    "border border-slate-200 bg-white text-slate-700 hover:border-indigo-300 hover:bg-indigo-50/40 focus-visible:ring-indigo-200",
  oscuro:
    "bg-white text-indigo-950 shadow-sm hover:bg-indigo-50 focus-visible:ring-white/40",
  fantasma:
    "text-slate-600 hover:text-indigo-700 focus-visible:ring-indigo-200",
};

const TAMANOS = {
  md: "px-4 py-2 text-sm",
  lg: "px-5 py-3 text-sm sm:text-base",
};

export const Boton = ({ as = "a", variante = "primario", tamano = "md", className, children, ...rest }) => {
  const tap = useTapAnimation();
  const Tag = as === "button" ? motion.button : motion.a;
  return (
    <Tag
      className={cn(
        "inline-flex cursor-pointer items-center justify-center gap-2 rounded-xl font-semibold transition-colors duration-200 focus-visible:outline-none focus-visible:ring-4 disabled:cursor-not-allowed disabled:opacity-60",
        VARIANTES[variante],
        TAMANOS[tamano],
        className,
      )}
      {...tap}
      {...rest}
    >
      {children}
    </Tag>
  );
};
